import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import AddEditPopup from "./addEditPopup";

/**
 * The section editor on its own route.
 *
 * Curating a hundred books needs the whole window — a modal wide enough for a
 * cover grid is a page with a scrim behind it. The form itself is unchanged;
 * `asPage` only swaps the modal chrome for a plain container.
 *
 * `/picks/new` creates, `/picks/:sectionId/edit` edits.
 */
const EditSectionPage = () => {
    const navigate = useNavigate();
    const { sectionId } = useParams();

    const backToList = () => navigate("/picks");

    return (
        <AddEditPopup
            asPage
            isVisible
            sectionId={sectionId ?? null}
            handleCloseModal={backToList}
            // A save calls onSuccess and then handleCloseModal, so navigating in
            // both would fire twice. The list refetches on mount anyway, which is
            // what onSuccess existed to trigger while this was a dialog.
            onSuccess={() => {}}
        />
    );
};

export default EditSectionPage;
